import giftgiver from '@/services/api/giftgiver';
import { getField, updateField } from 'vuex-map-fields';
import { CHECKBOX_TRUE_VALUE } from '@/constants/forms';
const defaultGiftgiverData = () => {
    return {
        email: null,
        phone_number: null,
        first_name: null,
        last_name: null,
        comment: null,
        category: null,
        chosen_warehouse: null
    };
};

const defaultRemoveGiftgiverData = () => {
    return {
        explanation: null,
        notification: CHECKBOX_TRUE_VALUE
    };
};

export default {
    namespaced: true,
    state: {
        giftgiverData: defaultGiftgiverData(),
        giftgiverCreators: [],
        removeGiftgiverData: defaultRemoveGiftgiverData(),
        explanation: null
    },
    getters: {
        getField,
        getGiftgiverData: (state) => state.giftgiverData,
        getRemoveGiftgiverData: (state) => state.removeGiftgiverData,
        getGiftgiverCreators: (state) => state.giftgiverCreators,
        getExplanation: (state) => state.explanation
    },
    mutations: {
        updateField,
        resetGiftgiverData (state) {
            state.giftgiverData = defaultGiftgiverData();
        },
        setGiftgiverCreators (state, payload) {
            state.giftgiverCreators = payload;
        },
        clearRemoveGiftgiverData (state) {
            state.removeGiftgiverData = defaultRemoveGiftgiverData();
        },
        mergeGiftgiverData (state, payload) {
            if (payload) {
                const defaultData = defaultGiftgiverData();
                defaultData.email = payload.email;
                defaultData.phone_number = payload.phone_number;
                defaultData.first_name = payload.first_name;
                defaultData.last_name = payload.last_name;
                defaultData.comment = payload.comment;
                defaultData.chosen_warehouse = payload.chosen_warehouse;
                if (payload.category != null) {
                    defaultData.category = payload.category.id;
                }
                state.giftgiverData = defaultData;
            }
        }
    },
    actions: {
        assingGiftgiver (context, data) {
            return giftgiver.assignGiftgiver(data);
        },
        removeGiftgiver (context, data) {
            return giftgiver.removeGiftgiver(data);
        },
        getGiftgiverCreators (context) {
            return giftgiver.getGiftgiverCreators().then((data) => {
                context.commit('setGiftgiverCreators', data.data.data);
            });
        },
        editGiftgiver (context, data) {
            return giftgiver.editGiftgiver(data);
        },
        resendMail (context, id) {
            return giftgiver.resendMail(id);
        },
        resendGiftGivingReportMail (context, id) {
            return giftgiver.resendGiftGivingReportMail(id);
        }
    }
};
